import app_config from "../environment/environment";

export const getCookie = (name: any) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// export const setCookie = (name: any, value: any, days: any = 365, domain = app_config.app_domain) => {
//     var expires = "";
//     if (days) {
//         var date = new Date();
//         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//         expires = "; expires=" + date.toUTCString();
//     }
//     document.cookie = name + "=" + (value || "") + expires + ";domain=" + domain + ";path=/";
// }
export const setCookie = (
    name: string,
    value: any,
    days: number = 365,
    domain: string | null = app_config.app_domain
  ) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
  
    let cookie = `${name}=${value || ""}${expires};path=/`;
  
    if (domain) {
      cookie += `;domain=${domain}`;
    }
  
    document.cookie = cookie;
  };

export const deleteCookie = (
  name: string,
  domain: string | null = app_config.app_domain
) => {
  let cookie = `${name}=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  
  if (domain) {
    cookie += `domain=${domain};`;
  }

  document.cookie = cookie;
};


